import StarterKit from '@tiptap/starter-kit';
import { Placeholder, CharacterCount } from '@tiptap/extensions';
import { TextStyle, Color, FontSize } from '@tiptap/extension-text-style';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Image from '@tiptap/extension-image';
import { TableKit } from '@tiptap/extension-table';
import { TaskList, TaskItem } from '@tiptap/extension-list';
import Youtube from '@tiptap/extension-youtube';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import { HtmlBlock } from './HtmlBlock';
import { PageBreak } from './PageBreak';
import { SlashCommands } from './SlashMenu';

export const buildExtensions = ({ placeholder, viewer = false } = {}) => {
  const extensions = [
    StarterKit.configure({
      link: {
        openOnClick: viewer,
        autolink: true,
        defaultProtocol: 'https',
        HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' },
      },
      heading: { levels: [1, 2, 3] },
    }),
    TextStyle,
    Color,
    FontSize,
    Highlight.configure({ multicolor: true }),
    TextAlign.configure({ types: ['heading', 'paragraph'] }),
    Image.configure({ HTMLAttributes: { class: 'wiki-image' } }),
    TableKit.configure({ table: { resizable: !viewer } }),
    TaskList,
    TaskItem.configure({ nested: true }),
    Youtube.configure({ nocookie: true, width: 640, height: 360 }),
    Subscript,
    Superscript,
    HtmlBlock,
    PageBreak,
    CharacterCount,
  ];

  if (!viewer) {
    extensions.push(
      Placeholder.configure({
        placeholder: placeholder || "Escreva aqui... Digite '/' para inserir blocos",
      }),
      SlashCommands
    );
  }

  return extensions;
};

export const textToDoc = (text) => {
  if (!text) return { type: 'doc', content: [{ type: 'paragraph' }] };
  return {
    type: 'doc',
    content: String(text)
      .split('\n')
      .map((line) => ({
        type: 'paragraph',
        ...(line.trim() ? { content: [{ type: 'text', text: line }] } : {}),
      })),
  };
};

export const normalizeContent = (content) => {
  if (!content) return null;
  if (typeof content === 'string') {
    try {
      return JSON.parse(content);
    } catch {
      return textToDoc(content);
    }
  }
  return content;
};
